import { FeatureFlagService } from "#services/api/feature-flag.service";
import { Component } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";

@Component({
  selector: "app-version-banner",
  templateUrl: "./version-banner.component.html",
  styleUrl: "./version-banner.component.scss",
  standalone: false,
})
export class VersionBannerComponent {
  constructor(
    private readonly _featureFlagService: FeatureFlagService,
    private readonly _router: Router,
    private readonly _route: ActivatedRoute
  ) {}

  id: string;

  ngOnInit(): void {
    this._route.paramMap.subscribe((params) => {
      this.id = params.get("id");
    });
  }

  useNewVersion() {
    this._featureFlagService.setFeatureFlag(true);
    this._router.navigate(["/admin/job-templates-v2"]);
  }
}
